module.exports = __webpack_public_path__ + "img/slash-circle-fill.1d7a1952.svg";